module.exports = "/_next/static/images/StayingAheadOfTheCurve-xs@2x-8da48cd8585297f526ef36670cff0a0c.webp";